import { CheckCircle2, RefreshCw, TriangleAlert, XCircle } from 'lucide-react'

import { Button, DiagnosticCopy } from '@krp/ui-kit'

import { QueryState } from '../../../shared/QueryState'
import type { AboutActions, AboutRowVm, AboutVm } from '../model/types'
import '../../../shared/platform.css'

/** Значок и слово вместе: состояние различается не только цветом (CLAUDE.md §7). */
function StateMark({ row }: { row: AboutRowVm }) {
  if (row.healthy) return <CheckCircle2 size={16} aria-hidden="true" />
  if (row.state === 'down') return <XCircle size={16} aria-hidden="true" />
  return <TriangleAlert size={16} aria-hidden="true" />
}

/**
 * «О приложении»: каждая служба продукта — версия, коммит, дата сборки, дата выкатки, состояние и время проверки.
 * Перечень приходит от шлюза (реестр на сервере), клиент своего списка не держит. На телефоне строки — карточками.
 */
export function AboutScreen({ vm, actions }: { vm: AboutVm; actions: AboutActions }) {
  return (
    <section aria-label="О приложении" className="platform-about">
      <div className="platform-about__toolbar">
        <Button
          variant="secondary"
          icon={<RefreshCw size={16} aria-hidden="true" />}
          onClick={actions.reload}
          actionId="platform.about.reload"
        >
          Обновить
        </Button>
        {vm.copyText !== '' && <DiagnosticCopy text={vm.copyText} label="Скопировать сводку" />}
      </div>
      <QueryState query={vm.query} emptyText="Шлюз не назвал ни одной службы" onRetry={actions.reload} />
      {vm.clientNotice !== null && (
        <p role="status">
          <TriangleAlert size={16} aria-hidden="true" /> {vm.clientNotice}
        </p>
      )}
      {vm.summary !== null && (
        <p role="status">
          <TriangleAlert size={16} aria-hidden="true" /> {vm.summary}
        </p>
      )}
      {vm.rows.length > 0 && (
        <>
          <p className="platform-about__generated">Список собран: {vm.generatedText}</p>
          <table className="platform-about__table">
            <thead>
              <tr>
                <th scope="col">Служба</th>
                <th scope="col">Версия</th>
                <th scope="col">Коммит</th>
                <th scope="col">Собрана</th>
                <th scope="col">Выкачана</th>
                <th scope="col">Состояние</th>
                <th scope="col">Проверено</th>
              </tr>
            </thead>
            <tbody>
              {vm.rows.map((row) => (
                <tr key={row.id} aria-label={row.name}>
                  <th scope="row" data-label="Служба">
                    {row.name}
                  </th>
                  <td data-label="Версия">{row.versionText}</td>
                  <td data-label="Коммит">{row.commitText}</td>
                  <td data-label="Собрана">{row.builtText}</td>
                  <td data-label="Выкачана">{row.startedText}</td>
                  <td data-label="Состояние">
                    <StateMark row={row} /> {row.stateText}
                    {row.note !== null && <span className="platform-about__note"> — {row.note}</span>}
                  </td>
                  <td data-label="Проверено">{row.checkedText}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  )
}
